export type QualityKey = 'good' | 'degraded' | 'poor' | 'insufficient' | 'unanalyzed';

// Färgerna bor kvar i varje vy — filterpillren är bleka, korten fyllda och
// diagrammet mättat. Det är namnen som måste vara desamma överallt: samma
// session ska inte heta en sak i listan och en annan i panelen bredvid.
export const QUALITY_LABELS: Record<QualityKey, string> = {
  good: 'God',
  degraded: 'Försämrad',
  poor: 'Dålig',
  insufficient: 'Otillräckligt underlag',
  unanalyzed: 'Inte analyserade',
};
